import { useEffect } from 'react';

/**
 * body 에 페이지 클래스를 붙인다.
 *
 * mobile.css · tablet.css 의 오버라이드가 `.page-index #hero …` 처럼
 * 이 클래스로 스코프되어 있어 라우트마다 반드시 갱신돼야 한다.
 */
export function useBodyClass(className) {
  useEffect(() => {
    if (!className) return undefined;
    document.body.classList.add(className);
    return () => document.body.classList.remove(className);
  }, [className]);
}
